import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import "yup-phone-lite";
import { AddressAutocomplete } from '../address-autocomplete';
import { StyledAsterisk, StyledFieldContainer, StyledFieldError, StyledFooter, StyledMessageError, StyledMessageSuccess, StyledNote, StyledSubmitButton, StyledText } from './email-form.styles';

export const EmailForm = ({ name, text, content, note, success, submit, error }: { name: string, text: string, content: any[], note: string, success: string, submit: string, error: string }) => {

  const [isError, setIsError] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const schema:any = {};
  content.map((field:any) => {
    schema[field.name] = Yup.string();

    if(field.model.apiKey === "form_field_email") {
      schema[field.name] = schema[field.name].email('Please enter a valid email address')
    }

    if(field.model.apiKey === "form_field_phone") {
      schema[field.name] = schema[field.name].phone("GB", `Please enter a valid phone number`)
    }

    if (field.required === true) {
      schema[field.name] = schema[field.name].required(field.choices ? `Please select one` : `Please enter your ${field.label.toLowerCase()}`)
    }
  })

  const validation = Yup.object().shape(schema);

  if (isSuccess) {
    return (
      <StyledMessageSuccess dangerouslySetInnerHTML={{ __html: success }} />
    )
  }

  const encode = (data: Record<string, string>) =>
  Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');

  return (
    <>
      {text && <StyledText dangerouslySetInnerHTML={{ __html: text }} />}

      <Formik
        initialValues={content.reduce((a, v) => ({ ...a, [v.name]: '' }), {})}
        validationSchema={validation}
        onSubmit={(values, { setSubmitting }) => {
          fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode({
              'form-name': name,
              ...values,
            }),
          }).then(response => {
            if (response.ok) {
              setIsSuccess(true);
              (window.dataLayer || []).push({ event: 'submit_form_success' });
            }
            else {
              setIsError(true);
            }
            setSubmitting(false);
          }).catch(() => {
            setIsError(true);
            setSubmitting(false);
          })
        }}
      >
        {({ errors, touched, isSubmitting, isValid, dirty, values }) => {

          return (
            <Form name={name} method="POST" data-netlify="true" data-netlify-honeypot="honey" noValidate>
              <input type="hidden" name="form-name" value={name} />
              <div style={{ display: 'none' }} aria-hidden="true">
                <label>
                  Don't fill this out if you're human:
                  <input type="text" name="honey" />
                </label>
              </div>
              
              {content.map((field, index) => {

                const as = field.model.apiKey === "form_field_text" && !!field.multiline ? "textarea" : field.model.apiKey === "form_field_dropdown" ? "select" : "input";
                const type = as === "input" ? (field.model.apiKey === "form_field_checkbox" ? "checkbox" : "text") : null;

                return (
                  <StyledFieldContainer key={index} $fieldType={type} $set={!!values[field.name]}>
                    <label htmlFor={field.name}>{field.label}</label>
                    <Field id={field.name} type={type} name={field.name} placeholder={field.placeholder || field.label} as={as}>
                      {as === "select" ? (
                        <>
                          <option disabled value="">{field.label}</option>
                          {field.options.map(({label, value}: {label: string, value: string}) => (<option key={value} value={value}>{label}</option>))}
                        </>
                      ) : null}
                    </Field>
                    {field.required === true &&
                      <StyledAsterisk width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.02349 5.78826L4.7641 4.29905L8.02349 2.78174L7.26484 1.48921L4.37071 3.5123L4.65171 0H3.1906L3.47157 3.5123L0.57744 1.48921L-0.181213 2.78174L3.07818 4.29905L-0.181213 5.78826L0.57744 7.10888L3.47157 5.0577L3.1906 8.57H4.65171L4.37071 5.0577L7.26484 7.10888L8.02349 5.78826Z" fill="#938B8B" />
                      </StyledAsterisk>
                    }
                    {errors[field.name] && touched[field.name] ? (<StyledFieldError>{errors[field.name] as string}</StyledFieldError>) : null}
                  </StyledFieldContainer>
                )
              })}

              <StyledNote dangerouslySetInnerHTML={{ __html: note }} />

              <StyledFooter>
                <StyledSubmitButton type="submit" disabled={isSubmitting || !isValid || !dirty}>{submit}</StyledSubmitButton>
                {isError && <StyledMessageError dangerouslySetInnerHTML={{ __html: error }} />}
              </StyledFooter>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}